<div style="float:left; width: 95%; height: calc(100% - 100px);">
  <jqxGrid #gridTarjetas [theme]="environment.tema" [width]="'100%'" [height]="'100%'" [source]="dataAdapterDirecciones"
    [appCellClick] [columnsresize]="true" [filterable]="false" [showfilterrow]="false" [columns]="columnsDirecciones"
    [sortable]="false" [altrows]="true" [showrowlines]="false" [filterrowheight]="30" [rowsheight]="25"
    [columnsheight]="25" [enablebrowserselection]="false" [localization]="langGrid"
    (onRowclick)="rowClickAsociarTarjeta($event)">
  </jqxGrid>
</div>